module.exports = __webpack_public_path__ + "img/4-4-marquee-1.cb74001a.jpg";